import { z } from 'zod';
import { tenantSlugSchema } from './slug.js';
import { isValidTimeZone } from './record-extras.js';
export const PASSWORD_MIN = 10;
export const PASSWORD_MAX = 128;
// Doğrulama iletileri kayıt formunda kullanıcıya AYNEN gösterilir (SignupPage `issue.message`): Türkçe yazılır; ileti
// verilmezse zod'un İngilizce varsayılanı ekrana çıkar (M6 WP 6.5 Türkçe taramasında ölçüldü).
export const signupInputSchema = z.object({
    companyName: z
        .string()
        .trim()
        .min(2, 'Şirket adı en az 2 karakter olmalı')
        .max(120, 'Şirket adı en çok 120 karakter olabilir'),
    legalName: z
        .string()
        .trim()
        .min(2, 'Ticari unvan en az 2 karakter olmalı')
        .max(200, 'Ticari unvan en çok 200 karakter olabilir')
        .optional(),
    slug: z
        .string()
        .trim()
        .min(3, 'Çalışma alanı adresi en az 3 karakter olmalı')
        .max(60, 'Çalışma alanı adresi en çok 60 karakter olabilir')
        .optional(),
    email: z
        .string()
        .trim()
        .toLowerCase()
        .check(z.email('Geçerli bir e-posta adresi girin'))
        .max(254, 'E-posta adresi en çok 254 karakter olabilir'),
    password: z
        .string()
        .min(PASSWORD_MIN, `Parola en az ${PASSWORD_MIN} karakter olmalı`)
        .max(PASSWORD_MAX, `Parola en çok ${PASSWORD_MAX} karakter olabilir`)
        .refine((p) => p.trim() === p, 'Parola boşlukla başlayıp bitemez'),
    firstName: z.string().trim().min(1, 'Ad gerekli').max(80, 'Ad en çok 80 karakter olabilir'),
    lastName: z.string().trim().min(1, 'Soyad gerekli').max(80, 'Soyad en çok 80 karakter olabilir'),
    /**
     * M3 K-M3-01: gerçek çalışma alanı boş başlar; demo ayrı, açıkça "Demo" işaretli bir çalışma alanıdır ve sonradan
     * gerçeğe/gerçekten demoya dönüştürülemez.
     */
    workspaceKind: z.enum(['real', 'demo']).default('real'),
});
export const signupResponseSchema = z.object({
    tenant: z.object({
        id: z.guid(),
        slug: tenantSlugSchema,
        name: z.string(),
        status: z.enum(['active', 'suspended', 'closing', 'closed']),
        isDemo: z.boolean().default(false),
    }),
    owner: z.object({ id: z.guid(), email: z.string(), role: z.string() }),
});
export const slugAvailabilityQuerySchema = z.object({ slug: z.string().trim().min(1).max(120) });
/**
 * M7 T1 (K-M7-02): açık kayıt kapısı. `GET /signup/status` yanıtı — sır içermez; arayüz kayıt bağlantısını ve kayıt
 * sayfasını bu duruma göre gösterir. Güvenlik sınırı API'dedir: kapalıyken `POST /signup` ve `GET /signup/slug-availability`
 * 403 `FORBIDDEN` + `details.reason = SIGNUP_CLOSED_REASON` döner.
 */
export const signupStatusSchema = z.object({ open: z.boolean() });
export const SIGNUP_CLOSED_REASON = 'signup_closed';
export const tenantSettingsSchema = z.object({
    shortName: z.string().trim().min(1).max(120),
    legalName: z.string().trim().max(200),
    language: z.enum(['tr', 'en']),
    country: z.string().length(2).toUpperCase(),
    timezone: z.string().min(3).max(64),
    clock24h: z.boolean(),
    phone: z.string().trim().max(40),
    currency: z.string().length(3).toUpperCase(),
    vatMode: z.enum(['exclusive', 'inclusive']),
    defaultVatRate: z.number().min(0).max(100),
    secondTaxEnabled: z.boolean(),
    secondTaxName: z.string().trim().max(40),
    secondTaxRate: z.number().min(0).max(100),
    importCostEnabled: z.boolean(),
    exchangeRateSource: z.enum(['manual', 'tcmb_buying', 'tcmb_selling']),
    profitMethod: z.enum(['purchase_price', 'cost']),
    decimalPlaces: z.union([z.literal(0), z.literal(2), z.literal(4), z.literal(6)]),
    roundingMode: z.enum(['half_up', 'half_even', 'down']),
    pdfFilenamePattern: z.string().trim().min(1).max(120),
});
/**
 * Şirketim güncellemesi (yalnız gönderilen alanlar). Saat dilimi IANA adı olmalıdır (v3.1 A1): geçersiz ad bütün takvim
 * hesaplarını bozardı; sabit ofset (`+03:00`) kabul edilmez. Okuma şeması (`tenantSettingsSchema`) saklanmış değeri olduğu gibi
 * taşır.
 */
export const tenantSettingsPatchSchema = tenantSettingsSchema
    .extend({
    timezone: z.string().min(3).max(64).refine(isValidTimeZone, 'geçerli bir saat dilimi seçin'),
})
    .partial()
    .strict();
//# sourceMappingURL=tenant.js.map